import { Routes } from '@angular/router';

export const v3DisplayCardsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./v3-display-cards.page').then((m) => m.V3DisplayCardsPage),
  },
];
